import React from 'react';

export const teamColors = {
  fenerbahce: '#FFED00', galatasaray: '#FF6600', besiktas: '#000000',
  antwerp: '#FF0000', club_brugge: '#0000FF', anderlecht: '#7B2D8E',
  union_sg: '#FFD700', genk: '#0066CC', gent: '#0099CC', standard: '#CC0000',
  ajax: '#CC0000', feyenoord: '#FF0000', psv: '#FF0000',
  arsenal: '#EF0107', chelsea: '#034694', liverpool: '#C8102E',
  manutd: '#DA291C', mancity: '#6CABDD', tottenham: '#132257',
  madrid: '#FFFFFF', barca: '#A50044', atletico: '#CB3524',
  psg: '#004170', marseille: '#2FAEE0', lyon: '#1A3C7A', monaco: '#E2001A',
  bayern: '#DC052D', leverkusen: '#E32221', dortmund: '#FDE100',
  inter: '#009BDB', ac_milan: '#FB090B', napoli: '#12A0D7', juventus: '#000000',
  boca_juniors: '#003DA5', river_plate: '#E2001A',
  // North American cities
  toronto: '#00205B', montreal: '#AF1E2D', new_york: '#003087',
  miami: '#F4793B', los_angeles: '#552583', boston: '#007A33', chicago: '#CE1141',
  // NHL teams
  maple_leafs: '#00205B', canadiens: '#AF1E2D', rangers: '#0038A8',
  bruins: '#FFB81C', blackhawks: '#CF0A2C',
  // NBA teams
  raptors: '#CE1141', knicks: '#F58426', heat: '#98002E',
  celtics: '#007A33', bulls: '#CE1141', lakers: '#552583',
  // MLS teams
  toronto_fc: '#E31837', cf_montreal: '#0033A0', red_bulls: '#ED1E36',
  inter_miami: '#F7B5CD', galaxy: '#00245D', revolution: '#C63323'
};

export const getTeamColor = (teamSlug) => {
  return teamColors[teamSlug?.toLowerCase()] || '#00d1ff';
};

export const formatNumber = (num) => {
  if (!num) return '0';
  if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
  if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
  return num.toLocaleString();
};

export const formatTimeAgo = (date) => {
  if (!date) return 'Never';
  const seconds = Math.floor((new Date() - date) / 1000);
  if (seconds < 60) return 'Just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
  return `${Math.floor(seconds / 604800)}w ago`;
};

export const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-black/90 border border-[#00ff41] p-3 rounded-lg">
        <p className="text-[#00ff41] font-semibold">{payload[0].payload.name || payload[0].payload.date}</p>
        {payload.map((entry, index) => (
          <p key={index} style={{ color: entry.color }} className="text-sm">
            {entry.name}: {entry.value}
          </p>
        ))}
      </div>
    );
  }
  return null;
};
